/**
 * @file paddleJS Hooks
 * @author wanzhongyun
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { getCmsDataInfo } from './../../api/pages/paddleCmsGetDataApi';
import {
    IHackBanner,
    IHackLight,
    IHackTimeLine,
    IHackTopic,
    IHackAwards,
    IHackRegister,
    IHackPartner,
    IHackQRCode,
    PaddleHackathonPartnerType,
} from './type';


const usePaddleHackathonHooks = () => {
    const [hackBanner, setHackBanner] = useState<IHackBanner>({
        backgroundImageUrl: '',
        registerWord: '',
        registerLink: '',
        detail: '',
        detailLink: ''
    });
    const [hackLight, setHackLight] = useState<IHackLight>({
        titleImageUrl: '',
        contentImageUrl: '',
        videoLink: '',
        videoPoster: ''
    });
    const [hackTimeLine, setHackTimeLine] = useState<IHackTimeLine>({
        titleImageUrl: '',
        simpleImageUrl: '',
        difficultyImageUrl: ''
    });
    const [hackTopic, setHackTopic] = useState<IHackTopic>({
        titleImageUrl: '',
        topicList: [],
        allTopicWord: '',
        allTopicLink: ''
    });
    const [hackAwards, setHackAwards] = useState<IHackAwards>({
        titleImageUrl: '',
        desc: '',
        detailLink: '',
        commonAwardsImg: '',
        specialAwardsImg: ''
    });
    const [hackRegister, setHackRegister] = useState<IHackRegister>({
        titleImageUrl: '',
        register: '',
        registerLink: '',
        joinCom: '',
        joinComLink: ''
    });
    const [hackPartner, setHackPartner] = useState<IHackPartner>({
        titleImageUrl: '',
        contentImageUrl: ''
    });
    const [hackQRCode, setHackQRCode] = useState<IHackQRCode>({
        registerLink: '',
        qrCodeUrl: ''
    });
    const [paddleHackathonPartner, setPaddleHackathonPartner] = useState<PaddleHackathonPartnerType>({
        titleImageUrl: '',
        content: [],
        description: ''
    })
    useMount(() => {
        (async () => {
            const res = await getCmsDataInfo({ requestUrl: '/paddleHackathon' })
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};
                data.hackathonBanner && setHackBanner(data.hackathonBanner);
                data.hackathonLight && setHackLight(data.hackathonLight);
                data.hackathonTimeLine && setHackTimeLine(data.hackathonTimeLine);
                data.hackathonBrowseTopic && setHackTopic(data.hackathonBrowseTopic);
                data.hackathonAwards && setHackAwards(data.hackathonAwards);
                data.hackathonRegister && setHackRegister(data.hackathonRegister);
                data.hackathonPartner && setHackPartner(data.hackathonPartner);
                data.hackQRCode && setHackQRCode(data.hackQRCode);
                data.paddleHackathonPartner && setPaddleHackathonPartner(data.paddleHackathonPartner);
            }
        })();
    });
    return {
        hackBanner,
        hackLight,
        hackTimeLine,
        hackTopic,
        hackAwards,
        hackRegister,
        hackPartner,
        hackQRCode,
        paddleHackathonPartner
    }
}

export default usePaddleHackathonHooks;